<template lang="">
  <div class="mt-3">
    <div class="row mb-5 ml-0 ml-lg-2">
      <div class="col-12 bg-gray rounded-sm col-lg-3">
        <div class="row p-2 pt-3">
          <custom-dropdown
            v-model="selectedAcademicYear"
            placeholder="Seleccione el año"
            fieldkey="id"
            fieldname="name"
            :options="academicyears"
            class="col-12 col-lg-9"
          />
          <action-button
            type="button"
            text="Buscar"
            i="fas fa-search"
            variant="success"
            class="mb-3 col-12 col-lg-3 mt-2 mt-lg-0"
            @click="onSearch"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <icon-view
          icon="far fa-history color-orange p-5"
          icon-size="1.5rem"
          title="Historial de PEI"
          variant="icon-view-extended"
          class="mb-2 icon-view-color-text"
        />
      </div>
      <div class="col-12">
        <div v-if="peiHistoryData.length > 0" class="search-result mt-3">
          <PeiHistoryRow
            v-for="row in peiHistoryData"
            :key="`${row.peiIdFormatted}`"
            ref="pei"
            :value="row"
            :has-saee10-report="row.hasSaee10Report"
            @getReportsPEIPS="getReportsPEIPS(row)"
            @getReportsPEIPSFromStorage="getReportsPEIPSFromStorage(row)"
          />
          <pagination
            v-if="pagination.totalItemCount > pagination.perPage"
            :data="pagination"
            :page-size="pagination.perPage"
            @pagination-go-page="onPageChanged"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CustomDropdown from "@/components/common/CustomDropDown";
import ActionButton from "@/components/common/ActionButton";
import IconView from "icon-view";
import Pagination from "pagination";
import PeiHistoryRow from "./PeiHistoryRow";
import documentsService from "@/services/documents";
import generalService from "@/services/pei/general";
import ReferralService from "@/modules/referral/api";

export default {
  name: "RecordPeiHistory",
  components: {
    CustomDropdown,
    ActionButton,
    IconView,
    Pagination,
    PeiHistoryRow
  },
  props: {
    studentId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      academicyears: [],
      selectedAcademicYear: null,
      peiHistoryData: [],
      pagination: {
        perPage: 10,
        currentPage: 1,
        totalItemCount: 0,
        pageCount: 0,
        count: 0
      }
    };
  },
  mounted() {},
  methods: {
    getReportsPEIPSFromStorage(item) {
      if (item.signedPeiAttachmentId) {
        return documentsService.downloadFromServer(item.signedPeiAttachmentId);
      } else {
        this.getReportsPEIPS(item);
      }
    },
    async getAcademicYears() {
      if (this.studentId == undefined && this.studentId == null) return;
      const {
        data: academicYearsList
      } = await ReferralService.getRecordHistoryFilterOptions(this.studentId);
      this.academicyears = academicYearsList;
    },
    getStudentPEI() {
      const year =
        this.selectedAcademicYear != null ? this.selectedAcademicYear.id : 0;
      if (this.studentId != undefined && this.studentId != null) {
        this.$ApiGet(
          "/api/studentreferrals/record/gethistory?studentSieId=" +
            this.studentId +
            "&year=" +
            year +
            "&pageNumber=" +
            this.pagination.currentPage +
            "&pageSize=" +
            this.pagination.perPage
        )
          .then(({ data }) => {
            this.peiHistoryData = data.data;
            this.pagination = {
              ...this.pagination,
              totalItemCount: data.totalItemCount,
              pageCount: data.pageCount,
              currentPage: data.currentPage,
              count: data.count
            };
          })
          .catch(err => {
            this.response = err;
          });
      }
    },
    onSearch() {
      this.pagination.currentPage = 1;
      this.getStudentPEI();
    },
    async onPageChanged(currentPage) {
      this.pagination.currentPage = currentPage;
      await this.getStudentPEI();
    },
    getReportsPEIPS(item) {
      let peiId = item.peiIdFormatted.replace("-", "");
      let self = this;

      let promise = new Promise(resolve => {
        self
          .$ApiGet("/api/report/pei/" + peiId)
          .then(res => {
            self.report = res.data;
            generalService.documentDownloadReport(
              self.report.content,
              self.report.filename
            );
            resolve(res.data);
          })
          .catch(err => {
            self.response = err;
            this.ShowToast("", err.response.data.message, "error");
          });
      });
      return promise;
    }
  },
  watch: {
    studentId: {
      handler: function(value) {
        if (value) {
          this.getAcademicYears();
          this.getStudentPEI();
        }
      },
      immediate: true
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep {
  .icon-view-extended {
    margin-bottom: 0.5rem;
    .dot {
      margin-right: 0.5rem !important;
      width: 40px !important;
      height: 40px !important;
      .title-icon {
        margin: 0 !important;
      }
    }
    .font-16.color-gray-7 {
      font-size: 24px !important;
    }
  }
}
</style>
